import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Shell from "./pages/Shell";
import Dashboard from "./pages/Dashboard";
import TransactionsPage from "./pages/Transactions";
import Accounts from "./pages/Accounts";
import Contacts from "./pages/Contacts";
import Payments from "./pages/Payments";
import Reports from "./pages/Reports";
import AI from "./pages/AI";
import Team from "./pages/Team";
import "./App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Shell /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/gelirler" element={<TransactionsPage type="gelir" />} />
        <Route path="/giderler" element={<TransactionsPage type="gider" />} />
        <Route path="/banka" element={<Accounts />} />
        <Route path="/cari" element={<Contacts />} />
        <Route path="/odemeler" element={<Payments />} />
        <Route path="/raporlar" element={<Reports />} />
        <Route path="/ai" element={<AI />} />
        <Route path="/ekip" element={<Team />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121722",
              border: "1px solid #334155",
              color: "#F8FAFC",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
